import queryString from 'qs';
import moment from 'moment';

const getRulesetsRequest = (queryParams) => {
  const queries = { yearMonth: moment(queryParams.yearMonth).format('YYYY-MM'), brand: queryParams.brand?.value };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getRulesetsRequest;
